import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetBulkOrderQueryOptions } from "@/requests/gen/react-query/bulk-order";
import OrderCreateForm from "../-form";
import { BulkOrderCrumbs } from "../../-crumbs";
import { useQueryState, parseAsBoolean } from "nuqs";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-order/$bulkOrderId/edit",
)({
  loader: ({ context: { queryClient }, params: { bulkOrderId } }) =>
    queryClient.ensureQueryData(getGetBulkOrderQueryOptions(bulkOrderId)),
  component: BulkOrderEditPage,
});

function BulkOrderEditPage() {
  const { bulkOrderId } = Route.useParams();
  const { data: bulk_order } = useSuspenseQuery(
    suspenseOptions(getGetBulkOrderQueryOptions(bulkOrderId)),
  );
  const [isReorder] = useQueryState(
    "is_reorder",
    parseAsBoolean.withDefault(bulk_order?.status === "Reorder"),
  );

  const title = isReorder ? "Bulk Reorder" : "Bulk Order";

  return (
    <div>
      <title>{`Edit Bulk Order ${bulkOrderId} - Legrande Health Portal`}</title>
      <BulkOrderCrumbs canEdit={true} isReorder={isReorder} />

      <Card>
        <CardHeader>
          <CardTitle>Edit {title}</CardTitle>
          <CardDescription>
            Select your entity and payment method to get started.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {bulk_order && (
            <OrderCreateForm bulk_order={bulk_order} isReorder={isReorder} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
